export default __webpack_public_path__ + "9ad4db07214d78a42eb7e3bbc9e8700c.svg";